import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type SharedByWorkspaceFragment = { workspaceId: string, workspaceName: string, workspaceLogo?: string | null, uri: string, icon?: string | null };


export type SharedByWorkspaceFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const SharedByWorkspaceFragmentDoc = /*#__PURE__*/ gql`
    fragment SharedByWorkspace on WorkspaceDetails {
  workspaceId
  workspaceName
  workspaceLogo
  uri
  icon
}
    `;